export default "__VITE_ASSET__45a7eb1f__"